export enum enPaymentType {
  FREE = 'G',
  NORMAL = 'N',
  SUBSCRIPTION = 'A',
  ECOMMERCE = ' '
}


// WEBPACK FOOTER //
// ./src/enums/enPaymentType.ts